import { ModalRootState } from '../index'
import { createSelector } from 'reselect'

export const getModalStack = (state: ModalRootState) => state.modal.common.modalStack

export const selectModalStack = createSelector(
  [getModalStack],
  (state) => state,
)